import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ 
  title = '', 
  value = 0, 
  maxValue = 100, 
  trend = 'neutral', 
  trendValue = 0,
  icon = 'Activity',
  description = ''
}) => {
  const getScoreColor = (score) => {
    if (score >= 80) return 'text-success';
    if (score >= 60) return 'text-warning';
    return 'text-error';
  };

  const getTrendIcon = () => {
    if (trend === 'up') return 'TrendingUp';
    if (trend === 'down') return 'TrendingDown';
    return 'Minus';
  };

  const getTrendColor = () => {
    if (trend === 'up') return 'text-success';
    if (trend === 'down') return 'text-error';
    return 'text-muted-foreground';
  };

  const percentage = (value / maxValue) * 100;

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 elevation-sm hover:elevation-md transition-smooth">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name={icon} size={20} color="var(--color-primary)" />
          </div>
          <div>
            <h3 className="text-sm md:text-base font-medium text-foreground font-body">
              {title}
            </h3>
            <p className="text-xs text-muted-foreground font-caption mt-1">
              {description}
            </p>
          </div>
        </div>
        <div className={`flex items-center gap-1 ${getTrendColor()}`}>
          <Icon name={getTrendIcon()} size={16} />
          <span className="text-xs font-medium font-caption">
            {Math.abs(trendValue)}%
          </span>
        </div>
      </div>

      <div className="space-y-3">
        <div className="flex items-baseline gap-2">
          <span className={`text-3xl md:text-4xl font-bold font-heading ${getScoreColor(value)}`}>
            {value}
          </span>
          <span className="text-sm text-muted-foreground font-body">
            / {maxValue}
          </span>
        </div>

        <div className="relative h-2 bg-muted rounded-full overflow-hidden">
          <div
            className={`absolute inset-y-0 left-0 rounded-full transition-smooth ${
              value >= 80 ? 'bg-success' : value >= 60 ? 'bg-warning' : 'bg-error'
            }`}
            style={{ width: `${percentage}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default MetricCard;